/* Do not change this file. */

import { jwtDecode } from "jwt-decode";
import { ROLE } from "@/helpers/const.js";

const auth = {
  state: {
    token: "",
    hash: ""
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_HASH(state, hash) {
      state.hash = hash;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("SET_TOKEN", token);
    },
    setHash({ commit }, hash) {
      commit("SET_HASH", hash);
    }
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getDecodedToken(_state, getters) {
      let token = getters.getToken;

      if (token) {
        token = jwtDecode(token);
      }

      return token;
    },
    getRole(_state, getters) {
      let token = getters.getDecodedToken;
      return token.role || "";
    },
    getFullname(_state, getters) {
      let token = getters.getDecodedToken;
      return token.fullname || "";
    },
    getIssuer(_state, getters) {
      let token = getters.getDecodedToken;
      return token.iss || "";
    },
    getONID(_state, getters) {
      let token = getters.getDecodedToken;
      return token.onid || "";
    },
    getSession(_state, getters) {
      let token = getters.getDecodedToken;
      return token.sub || "";
    },
    getTokenCourseId(_state, getters) {
      let token = getters.getDecodedToken;
      return token.course || "";
    },
    getExpirationTime(_state, getters) {
      let token = getters.getDecodedToken;
      return token.exp || 0;
    },
    getExpirationTimeRemaining(_state, getters) {
      if (!getters.getExpirationTime) {
        return 0;
      }
      let currentTime = Math.round(new Date().getTime() / 1000);

      return getters.getExpirationTime - currentTime;
    },

    /*
     * Does the user have a valid token?
     */
    isAuthenticated(_state, getters) {
      let token = getters.getDecodedToken;

      let isAuth = true;

      if (!token) {
        isAuth = false;
      }

      if (getters.getExpirationTimeRemaining < 0) {
        isAuth = false;
      }

      return isAuth;
    },
    isAdmin(_state, getters) {
      let token = getters.getDecodedToken;
      return getters.isAuthenticated && token.role === ROLE.ADMIN;
    },
    getHash(state) {
      return state.hash;
    },
    parseHash(state) {
      let hash = state.hash;

      let result = hash.split("&").reduce(function (res, item) {
        let parts = item.split("=");
        res[parts[0]] = parts[1];
        return res;
      }, {});

      return result;
    },
    getCanvasImage(_state, getters) {
      let user_image = decodeURIComponent(getters.parseHash?.user_image);
      return user_image !== "undefined" ? user_image : ""; // Defined by LTI
    },
    getCanvasCourseId(_state, getters) {
      let course_id = decodeURIComponent(getters.parseHash?.course_id);
      return course_id !== "undefined" ? course_id : ""; // Defined by LTI
    },
    getCanvasUserId(_state, getters) {
      let canvas_user_id = decodeURIComponent(
        getters.parseHash?.canvas_user_id
      );
      return canvas_user_id !== "undefined" ? canvas_user_id : ""; // Defined by LTI
    }
  }
};

export default auth;
